import { render, staticRenderFns } from "./NaoEncontrado.vue?vue&type=template&id=6a30a86c&scoped=true&"
import script from "./NaoEncontrado.vue?vue&type=script&lang=js&"
export * from "./NaoEncontrado.vue?vue&type=script&lang=js&"
import style0 from "./NaoEncontrado.vue?vue&type=style&index=0&id=6a30a86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30a86c",
  null
  
)

export default component.exports